// extracted by mini-css-extract-plugin
export default {"root":"DownloadInvoicePdfButton_root__muxs1"};